<template>
  <div class="input-multi-select">
    <div class="row">
      <div class="col-12">
        <input class="input-multi-select__filter" type="text" v-model="filterString" placeholder="filter">
      </div>
      <div class="col-6">
        <div class="input-multi-select__label">Available Options</div>
      </div>
      <div class="col-6">
        <div class="input-multi-select__label">Selected Options</div>
      </div>
      <div class="input-multi-select__options col-6">
        <div
          class="input-multi-select__option"
          v-for="option in filteredOptions"
          @click="selectOption(option.value)"
        >{{ option.label }}</div>
      </div>
      <draggable v-model="selectedOptions" class="input-multi-select__selected col-6">
        <div 
          class="input-multi-select__selected-option"
          v-for="option in selectedOptions"
          @click="unselectOption(option.value)"
        >{{ option.label }}</div>
      </draggable v-model="selectedOptions">
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import Draggable from 'vuedraggable'
export default {
  components: { Draggable },

  props: ['options', 'value'],

  data () {
    return {
      filterString: ''
    }
  },

  computed: {
    filteredOptions () {
      return _.filter(this.options, option => {
        // Initially filter out already selected values
        if (this.selectedOptionValues.includes(option.value)) {
          return false
        }

        // Then filter based on the filter string
        if (this.filterString.length) {
          return option.label.toLowerCase().includes(this.filterString.toLowerCase())
        } else {
          return true
        }
      })
    },

    selectedOptions: {
      get () {
        // Use the order of selectedOptionValues rather than options, allows draggable to work
        let selectedOptions = []
        this.selectedOptionValues.forEach(selectedOptionValue => {
          selectedOptions.push(_.find(this.options, option => {
            return option.value === selectedOptionValue
          }))
        })
        return selectedOptions
      },
      set (selectedOptions) {
        this.$emit('input', selectedOptions.map(option => option.value))
      }
    },

    selectedOptionValues () {
      return this.value
    }
  },

  methods: {
    selectOption (value) {
      if (!this.selectedOptionValues.includes(value)) {
        this.selectedOptionValues.push(value)
        this.$emit('input', this.selectedOptionValues)
      }
    },

    unselectOption (value) {
      let newSelectedOptionValues = _.filter(this.selectedOptionValues, selectedOptionValue => {
        return selectedOptionValue === value ? false : true
      })
      this.$emit('input', newSelectedOptionValues)
    }    
  }

}
</script>
<style lang="scss">
.input-multi-select {
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  padding: 7px 7px 7px 14px;
  // display: flex;

  &__label {
    font-weight: 800;
  }

  &__options, &__selected {
    // width: 50%;
    max-height: 200px;
    overflow: scroll;
  }

  &__option, &__selected-option {
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
  }
}
</style>